let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lNLjV"), load("f7f51")]).then(() => parcelRequire('5dDzc'));